import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import StarRating from 'react-star-rating-component';
import { Text } from '@front10/base-elements';

const Rating = (props, ref) => {
  const {
    title,
    ariaLabel,
    value,
    minValue = 0,
    starCount,
    onStarClick,
    halfStar = false,
    renderStarIcon,
    renderStarIconHalf,
    containerSettings = {}
  } = props;
  const focusRef = React.useRef(null);
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(containerSettings, { direction, theme });

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        focusRef.current.focus();
      }
    }),
    []
  );

  React.useEffect(() => {
    focusedElement();
  }, [value]);

  const handleKey = (event) => {
    const { key } = event;
    const keyNumber = Number(key); // e.g. "1" => 1, "ArrowUp" => NaN
    let value1 = minValue > value ? minValue : value;
    if (keyNumber) {
      if (Number.isInteger(keyNumber) && keyNumber > 0 && keyNumber <= starCount) {
        value1 = keyNumber;
      }
    } else {
      if ((key === 'ArrowUp' || key === 'ArrowRight') && value < starCount) {
        value1 += halfStar ? 0.5 : 1;
      } else if ((key === 'ArrowDown' || key === 'ArrowLeft') && value > halfStar ? 0.5 : 1) {
        value1 -= halfStar ? 0.5 : 1;
      }
    }
    if (value1 > 0 && value !== value1) {
      onStarClick(value1);
    }
  };

  const focusedElement = () => {
    focusRef.current.focus();
  };

  return (
    <>
      <Text variant="text.fontSize6" mb="2">
        {title}
      </Text>
      <div
        ref={focusRef}
        role="listbox"
        aria-orientation="horizontal"
        aria-label={ariaLabel}
        onKeyDown={handleKey}
        tabIndex={0}
        className={className}
        style={style}
      >
        <StarRating
          editing={true}
          name="rate1"
          starCount={starCount}
          value={minValue > value ? minValue : value}
          onStarClick={onStarClick}
          renderStarIcon={renderStarIcon}
          renderStarIconHalf={renderStarIconHalf}
        />
      </div>
    </>
  );
};

export default React.forwardRef(Rating);
